import { useEffect } from 'react';
import useRecordSubject from '../crm_ui/profile/hooks/useRecordSubject';
import { normalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
import { useSetCopilotAppContext } from 'copilot-toolkit/hooks/useSetCopilotAppContext';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const CopilotAppContext = ({
  children
}) => {
  const setCopilotPageContext = useSetCopilotAppContext();
  const {
    objectType,
    subjectId
  } = useRecordSubject();
  useEffect(() => {
    if (!subjectId || !objectType) {
      return;
    }
    setCopilotPageContext({
      crmObjectContext: {
        objectId: Number(subjectId),
        objectTypeId: normalizeTypeId(objectType)
      }
    });
  }, [objectType, setCopilotPageContext, subjectId]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export default CopilotAppContext;